module.exports = __webpack_public_path__ + "static/media/remove.752b1dba.svg";